import React from 'react';
import CombinedMenu from '../components/CombinedMenu';

const MainLayout: React.FC = () => {
  return (
    <div style={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <CombinedMenu />
    </div>
  );
};

export default MainLayout;
